import React from 'react'
import PropTypes from 'prop-types'
import {
  MdEmail,
  MdLocationOn,
  MdPhone,
  MdSms,
  MdVideocam
} from 'react-icons/md'
import types from './types'
import Text from '../Text/Text'
import Whatsapp from '../Icons/Whatsapp'
import Flex from '../Flex/Flex'

const Interation = (props) => {
  const { type } = props

  const renderText = (typeid) => {
    switch (typeid) {
      case types.TELEPHONE: {
        return (
          <>
            <MdPhone color="#737373" />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="Telefone"
            />
          </>
        )
      }
      case types.EMAIL: {
        return (
          <>
            <MdEmail color="#737373" />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="E-mail"
            />
          </>
        )
      }
      case types.WHATSAPP: {
        return (
          <>
            <Whatsapp />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="Whatsapp"
            />
          </>
        )
      }

      case types.SMS: {
        return (
          <>
            <MdSms color="#737373" />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="SMS"
            />
          </>
        )
      }

      case types.VIDEO_CONFERENCE: {
        return (
          <>
            <MdVideocam color="#737373" />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="Video chamada"
            />
          </>
        )
      }
      default: {
        return (
          <>
            <MdLocationOn color="#737373" />
            <Text
              size="xxs"
              color="gray"
              lineHeight="18px"
              margin="0px 0px 0px 5px"
              value="Visita"
            />
          </>
        )
      }
    }
  }
  return <Flex alignItems="center">{renderText(type)}</Flex>
}

Interation.defaultProps = {
  type: null
}

Interation.propTypes = {
  type: PropTypes.number
}

export default Interation
